import type { PropsWithChildren } from "react";
import { IbanXSBanksCountriesPivotContext } from "./IbanXSBanksCountriesPivotContext";
import useIbanXSBanksCountriesPivot from "./useIbanXSBanksCountriesPivot";

const IbanXSBanksCountriesPivotProvider = ({ children }: PropsWithChildren) => (
    <IbanXSBanksCountriesPivotContext.Provider
        value={useIbanXSBanksCountriesPivot()}
    >
        {children}
    </IbanXSBanksCountriesPivotContext.Provider>
);

export default IbanXSBanksCountriesPivotProvider;
